import { TranslationKeysByPath } from '@/localization';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

type UnifiedProfileSectionEmptyMessageProps = {
  labelKey: TranslationKeysByPath<'unifiedProfile'>;
};
export const UnifiedProfileSectionEmptyMessage: FC<UnifiedProfileSectionEmptyMessageProps> = ({ labelKey }) => {
  const { t } = useTranslation('unifiedProfile');

  return <p className='px-6 py-[1.625rem] text-center text-sm font-medium text-primary-900'>{t(labelKey as any)}</p>;
};
